"use strict";

exports.__esModule = true;
exports.AuditLogDetails = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactRouterCompat = require("../../../Utils/reactRouterCompat");
var _prismjs = _interopRequireDefault(require("prismjs"));
var _Core = require("../../Core");
var _App = require("../../App");
var _useAuditLogDetailsController = require("./useAuditLogDetailsController");
var _System = require("../../../System");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _reactDiffViewer = _interopRequireDefault(require("react-diff-viewer"));
var _downloadData = require("../../../Utils/downloadData");
var _styledComponents = require("styled-components");
var SandvikTheme = _interopRequireWildcard(require("../../../Themes/sandvik"));
var SandvikV2Theme = _interopRequireWildcard(require("../../../Themes/sandvik-v2"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AuditLogDetails = exports.AuditLogDetails = (0, _reactRouterCompat.withRouter)(function AuditLogDetailsWithRouter(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var theme = _react["default"].useContext(_styledComponents.ThemeContext);
  var width = props.width,
    height = props.height,
    _props$isFullScreen = props.isFullScreen,
    isFullScreen = _props$isFullScreen === void 0 ? false : _props$isFullScreen,
    auditLogId = props.auditLogId;
  var _useAuditLogDetailsCo = (0, _useAuditLogDetailsController.useAuditLogDetailsController)(props),
    isLoading = _useAuditLogDetailsCo.isLoading,
    data = _useAuditLogDetailsCo.data,
    error = _useAuditLogDetailsCo.error,
    handleClose = _useAuditLogDetailsCo.handleClose;
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null);
  }
  var auditLogDetails = data[0];
  if (error || !auditLogDetails) {
    var fetchError = error || new Error("Audit Log Not Found");
    return /*#__PURE__*/_react["default"].createElement(_Core.UhOh, {
      error: fetchError,
      title: translate("AuditLogDetails.fetchError", "Unable to fetch Audit Log Details")
    });
  }
  function isObject(obj) {
    return obj !== undefined && obj !== null && obj.constructor == Object;
  }
  function isObjectOrArrayOfObject(value) {
    if (Array.isArray(value) && value.length > 0) {
      return isObject(value[0]);
    }
    return isObject(value);
  }
  function formatDetailsValues(details) {
    if (isObjectOrArrayOfObject(details)) {
      return JSON.stringify(details, null, 2);
    }
    return details;
  }
  var highlightSyntax = function highlightSyntax(line) {
    var value = line;
    if (line === undefined) {
      value = "";
    }
    return /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        display: "inline"
      }
      // The only sanctioned dangerouslySetInnerHTML in the codebase. Prism
      // HTML-encodes token text, so the audit-log diff content it is given
      // cannot introduce markup. Do not pass anything here that has not been
      // through a sanitizer or an encoder. (VAPT-02)
      // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: _prismjs["default"].highlight(value, _prismjs["default"].languages.javascript)
      }
    });
  };
  var sandvikThemes = [SandvikTheme.themeName, SandvikV2Theme.themeName];
  var sandvikStyles = {
    variables: {
      light: {
        diffViewerBackground: "#565656",
        diffViewerColor: "#FFF",
        addedBackground: "#044B53",
        addedColor: "white",
        removedBackground: "#632F34",
        removedColor: "white",
        wordAddedBackground: "#055d67",
        wordRemovedBackground: "#7d383f",
        addedGutterBackground: "#034148",
        removedGutterBackground: "#632b30",
        gutterBackground: "#8F8F8F",
        gutterBackgroundDark: "#262933",
        highlightBackground: "#2a3967",
        highlightGutterBackground: "#2d4077",
        codeFoldGutterBackground: "#787878",
        codeFoldBackground: "#707070",
        emptyLineBackground: "#565656",
        gutterColor: "#FFF",
        addedGutterColor: "#FFF",
        removedGutterColor: "#FFF",
        codeFoldContentColor: "#FFF",
        diffViewerTitleBackground: "#2f323e",
        diffViewerTitleColor: "#555a7b",
        diffViewerTitleBorderColor: "#353846"
      }
    }
  };
  var getDetailsViewContent = function getDetailsViewContent() {
    return /*#__PURE__*/_react["default"].createElement(_Core.DetailsContainer, {
      "data-testid": "AuditLogDetailsView",
      width: width - 30,
      height: height,
      isFullScreen: isFullScreen
    }, /*#__PURE__*/_react["default"].createElement(_Core.DetailsHeader, {
      isFullScreen: isFullScreen,
      showRightAligned: true
    }, /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonContainer, null, /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonSubContainer, null, /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonItemLeft, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "AuditLogDetails.downloadButton.previous",
      small: true,
      minimal: true,
      icon: _icons.IconNames.FLOPPY_DISK,
      onClick: function onClick() {
        (0, _downloadData.downloadData)(formatDetailsValues(auditLogDetails.previousValue), "previous_" + Date.now().valueOf(), "txt");
      }
    })), /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonItemCenter, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: "3px",
        fontWeight: 600
      },
      "data-testid": "AuditLogDetails.info.previous"
    }, translate("AuditLogDetails.previousValue.info", "Previous value"))), /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonItemRight, null, " ", /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), " ")), /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonSubContainer, null, /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonItemLeft, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "AuditLogDetails.downloadButton.current",
      small: true,
      minimal: true,
      icon: _icons.IconNames.FLOPPY_DISK,
      onClick: function onClick() {
        (0, _downloadData.downloadData)(formatDetailsValues(auditLogDetails.value), "changed_" + Date.now().valueOf(), "txt");
      }
    })), /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonItemCenter, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        marginTop: "3px",
        fontWeight: 600
      },
      "data-testid": "AuditLogDetails.info.current"
    }, translate("AuditLogDetails.currentValue.info", "Changed value"))), /*#__PURE__*/_react["default"].createElement(_Core.HeaderButtonItemRight, null, !isFullScreen ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: (0, _System.getScreenURL)("AuditLogDetails", {
        id: auditLogId
      }),
      target: "_blank",
      rel: "noreferrer noopener"
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "AuditLogDetails.fullScreenButton.openDocument",
      minimal: true,
      icon: _icons.IconNames.DOCUMENT_OPEN
    })) : /*#__PURE__*/_react["default"].createElement(_core.Button, {
      minimal: true,
      icon: _icons.IconNames.CROSS,
      onClick: handleClose,
      "data-testid": "AuditLogDetails.fullScreenButton.closeDocument"
    }))))), /*#__PURE__*/_react["default"].createElement(_Core.DetailsSectionWrapper, {
      isFullScreen: true
    }, /*#__PURE__*/_react["default"].createElement(_Core.DetailsSection, null, /*#__PURE__*/_react["default"].createElement(_reactDiffViewer["default"], {
      oldValue: String(formatDetailsValues(auditLogDetails.previousValue)),
      newValue: String(formatDetailsValues(auditLogDetails.value)),
      splitView: true,
      styles: sandvikThemes.indexOf(theme == null ? void 0 : theme.themeName) !== -1 ? sandvikStyles : {},
      renderContent: highlightSyntax,
      hideLineNumbers: true
    }))));
  };
  if (isFullScreen) {
    return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
      title: translate("AuditLogDetails.title", "Audit Log Details"),
      "data-testid": "AuditLogDetails"
    }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
      title: translate("AuditLogDetails.navbar.title", "Audit Log")
    }), getDetailsViewContent()));
  }
  return /*#__PURE__*/_react["default"].createElement(_Core.DetailsWrapper, {
    "data-testid": "AuditLogDetailsWrapper",
    isFullScreen: isFullScreen,
    width: width,
    height: height
  }, getDetailsViewContent());
});